import React, { useState } from "react";
import ReceptionMenu from "./ReceptionMenu";

import './Reception.css';
import Home from "./Home";
import NotPlanned from "./NotPlanned";
import Complete from "./Complete";
import { useSelector, useDispatch } from "react-redux";
import { notifyPerson, resetNotifyError } from '../../store/ReceptionStore';
import Documents from "./Documents";
import { Person } from "../../domain/Person";
import GuestCardStep from "./GuestCardStep";
import SelectHostStep from "./SelectHostStep";

const ReceptionHome: React.FC = () => {
    const dispatch = useDispatch();
    const receptionState = useSelector((state: any) => state.receptionState);
    const [activeStep, setActiveStep] = useState("home");
    const [greeter, setGreeter] = useState<Person | undefined>(undefined);

    const setStep = (step: string) => setActiveStep(step);
    const setHost = (person: Person) => setGreeter(person);
    const notify = (person?: Person) => dispatch(notifyPerson(person ? person.id : receptionState.settings.visitorHandler.id) as any);
    const skipGuestBook = true;

    if (!receptionState.settings) {
        return <div>Waiting for settings....</div>;
    }

    if (receptionState.notificationError) {
        return (
            <div>
                Error!
                <div onClick={() => {
                    dispatch(resetNotifyError());
                    setActiveStep("home");
                }}>CLICK HERE to try again</div>
            </div>
        );
    }

    return (
        <>
            <ReceptionMenu active={activeStep} startOverAction={() => { setActiveStep("home"); setGreeter(undefined); }} />
            <div className='clearfix' />
            <div className='reception'>
                {activeStep === "home" && <Home changeStepClick={setStep} />}
                {activeStep === "notPlanned" && <NotPlanned notifyAction={notify} changeStepClick={setStep} />}
                {activeStep === "selectHost" && <SelectHostStep notifyAction={notify} changeStepClick={setStep} changeGreeterClick={setHost} />}
                {activeStep === "complete" && <Complete changeStepClick={(step: string) => {
                    setActiveStep(step);
                    setGreeter(undefined);
                }} />}
                {activeStep === "documents" &&
                    <Documents
                        changeStepClick={setStep}
                        documents={receptionState.settings.documents}
                        greeter={greeter || receptionState.settings.visitorHandler}
                    />
                }
                {activeStep === "guestCard" &&
                    <GuestCardStep
                        changeStepClick={setStep}
                        greeter={greeter || receptionState.settings.visitorHandler}
                        skipGuestBook={skipGuestBook}
                    />
                }
            </div>
        </>
    );
};

export default ReceptionHome;